import React, { memo, useState, useRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { MidAdWrapper, MidInningAdBackgroud } from './ad.style';
import VideoAd from './VideoAd';
import DisplayAd from './DisplayAd';
import useAds from '@gameday/utils/hooks/useAds';
const VIDEOTYPE = 'video';

const CommercialBreak = ({
    viewType,
    transitionFromBreak,
    transitionToBreak,
    vidAdsEnabled,
    midInningAdConfig = {},
    adComplete,
    adStartedAction,
    adEnded,
    adStarted,
    adType,
    adId,
    type
}) => {
    const AdsInfo = useAds();
    const { adConf: { adsConfig } = {} } = AdsInfo;
    const { units, prerollIu, pp, ui } = adsConfig || {};
    const hasPrerollConfig = !!(prerollIu && pp && ui);
    const hasBannerUnits = !!units;
    const matchedAdType = adType === type;
    const disableAds = !matchedAdType || (!hasPrerollConfig && !hasBannerUnits);
    const [showAdCom, setShowAdCom] = useState(false);
    const commercialTimeout = useRef({
        current: null
    });

    useEffect(() => {
        if (adEnded) {
            clearTimeout(commercialTimeout.current);
            commercialTimeout.current = null;
            setShowAdCom(false);
            adStartedAction(false);
        } else if (transitionToBreak) {
            clearTimeout(commercialTimeout.current);
            commercialTimeout.current = setTimeout(function () {
                commercialTimeout.current = null;
                setShowAdCom(true);
                adStartedAction(true);
            }, 12000);
        } else if (transitionFromBreak || commercialTimeout.current) {
            clearTimeout(commercialTimeout.current);
            commercialTimeout.current = null;
            setShowAdCom(false);
            adStartedAction(false);
        }
    }, [transitionFromBreak, transitionToBreak, vidAdsEnabled, adEnded, adStarted]);

    if (!showAdCom || disableAds) {
        return null;
    }

    return (
        <>
            <MidInningAdBackgroud />
            {adType === VIDEOTYPE && type === VIDEOTYPE ? <MidAdWrapper $type={viewType}><VideoAd midInningAdConfig={midInningAdConfig} adComplete={adComplete} /></MidAdWrapper> : <DisplayAd viewType={viewType} adId={adId} />}
        </>
    );
};

CommercialBreak.propTypes = {
    viewType: PropTypes.string,
    transitionFromBreak: PropTypes.bool,
    transitionToBreak: PropTypes.bool,
    vidAdsEnabled: PropTypes.bool,
    midInningAdConfig: PropTypes.object,
    adComplete: PropTypes.func,
    adEnded: PropTypes.bool,
    adType: PropTypes.string,
    adId: PropTypes.string,
    type: PropTypes.string,
    adStartedAction: PropTypes.func,
    adStarted: PropTypes.bool
};

export default memo(CommercialBreak);
